import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is Peps 4 Pets a pharmacy or a retailer?",
    a: "No. Peps 4 Pets is an informational reference site for veterinary research peptides. All content is intended for licensed research professionals and is strictly educational.",
  },
  {
    q: "Are these compounds safe for pets?",
    a: "The compounds referenced are research-grade materials only. They are not FDA-approved medications. Any application to an animal must be under the direction of a licensed veterinarian.",
  },
  {
    q: "How do you verify purity?",
    a: "Every batch is independently tested by a third-party analytical laboratory using HPLC and Mass Spectrometry. Certificates of Analysis (COA) are attached to each order.",
  },
  {
    q: "Where are the peptides sourced?",
    a: "All peptides are synthesized by USA-based partner facilities operating with documented QMS controls and full lot traceability.",
  },
  {
    q: "What does the customer portal do?",
    a: "The customer portal allows verified accounts to review order history, live shipment progress (Processing → Shipped → Delivered), and download all associated documentation.",
  },
  {
    q: "Why 21+ age verification?",
    a: "We restrict site access to adults 21 and older to align with responsible research content standards, even though nothing on this site is intended for consumption.",
  },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <div className="eyebrow mb-4">FAQ · Frequently Asked</div>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight">
        Questions,
        <br />
        answered clearly.
      </h1>
      <p className="mt-4 text-slate-600 text-base">The details behind the documentation.</p>

      <Accordion type="single" collapsible className="mt-10 border-t border-slate-200">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left text-slate-900 font-display text-lg hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
